module.exports = __webpack_public_path__ + "img/gas.2af3bd5.svg";